import Fundatio from "../../../layouts/apps/Fundatio";
import LinkedText from "../../../components/LinkedText";
import {faEnvelope} from "@fortawesome/free-solid-svg-icons";

export default function FundatioLicense() {
    const rightContent = (
        <div>
            <p>This is a legal agreement between you (the user) and me (Çağrı Gökpunar, the developer of Fundatio).</p>

            <h3>1. License Grant</h3>
            <p>You are granted a non-exclusive, non-transferable license to download, install, and use Fundatio on any
                macOS device that you personally own or control. This license is for personal use only.</p>

            <h3>2. Restrictions</h3>
            <p>You may not:</p>
            <ul>
                <li>Redistribute, sell, or sublicense the app.</li>
                <li>Modify or reverse engineer the app.</li>
                <li>Use the app in commercial projects without permission.</li>
            </ul>

            <h3>3. Ownership</h3>
            <p>I retain full ownership of the source code, design, and intellectual property of Fundatio. You're free
                to use the app, but the rights to the software remain mine.</p>

            <h3>4. Warranty Disclaimer</h3>
            <p>Fundatio is provided "as is", with no warranties or guarantees. I've done my best to make it stable and
                useful, but I can't promise it will work perfectly in all situations.</p>

            <h3>5. Limitation of Liability</h3>
            <p>I'm not responsible for any loss of data, financial information, or productivity caused by the use or
                misuse of Fundatio.
            </p>

            <h3>6. Termination</h3>
            <p>You can stop using Fundatio anytime. If you violate the terms of this agreement, your license will be
                terminated automatically.</p>

            <h3>7. Governing Law</h3>
            <p>This agreement is governed by the laws of the Republic of Turkey.</p>

            <h3>8. Contact</h3>
            <p>If you have any questions, feel free to reach out: </p>
            <LinkedText text={"cagri@mpospirit.com"} href={"mailto:cagri@mpospirit.com"} icon={faEnvelope}></LinkedText>
        </div>
    )
    return (
        <div className="cogio-license-page">
            <Fundatio rightContent={rightContent}/>
        </div>
    )
}